<template>
  <section class="wrapper">
    <app-login-form></app-login-form>
  </section>
</template>

<script>

import AppLoginForm from "@/components/backend/AppLoginForm";

export default {
  components: {AppLoginForm},

}
</script>

<style scoped>

.wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

button {
  border: 0;
}

.tabs {
  margin-top: 20px;
  text-align: center;
}

h1 {
  text-align: center;
  text-transform: uppercase;
}

</style>